import { DiagramViews } from "../models/diagram-views.model";

/**
 * @description initial grid config
 */
export function diagramConfig() {
    return {
        view: DiagramViews.GRID,
        readonly: false,
        containerID: null,
        plugins: [],
        oneAtATime: false
    };
}
